export default __webpack_public_path__ + "fcb532a05dd4b09c2d08f520d82cb0b2.svg";